var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSelectNotice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uADF8\\uB8F9 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.681,
    height: 20.435,
    viewBox: "0 0 19.681 20.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14",
    d: "M817.838.232a2.2 2.2 0 0 0-2.32.221.993.993 0 0 0-.08.068l-4.184 3.934h-1.788a3.018 3.018 0 0 0-3.014 3.014v5.5a3.018 3.018 0 0 0 3.014 3.014h1.793l4.179 3.932a1 1 0 0 0 .08.068 2.21 2.21 0 0 0 3.549-1.759V2.212a2.2 2.2 0 0 0-1.229-1.98m-.781 17.99a.188.188 0 0 1-.112.18.185.185 0 0 1-.184 0l-4.416-4.155a1 1 0 0 0-.688-.273h-2.191a1.006 1.006 0 0 1-1-1V7.47a1.006 1.006 0 0 1 1-1h2.191a1 1 0 0 0 .732-.319l4.373-4.111a.184.184 0 0 1 .184 0 .188.188 0 0 1 .112.18z",
    transform: "translate(-806.451)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 15",
    d: "M846.427 22.923h-3.357a1 1 0 0 0 0 2.01h3.358a1 1 0 0 0 0-2.01",
    transform: "translate(-827.751 -13.71)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 16",
    d: "M843.753 11.136a1.007 1.007 0 0 0 .427-.1l2.59-1.217A1 1 0 0 0 845.915 8l-2.589 1.217a1.005 1.005 0 0 0 .428 1.915",
    transform: "translate(-828.159 -4.73)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 17",
    d: "M846.656 36.221 844.066 35a1 1 0 1 0-.855 1.819l2.59 1.217a1 1 0 1 0 .855-1.819",
    transform: "translate(-828.091 -20.878)",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelectNotice);
export default __webpack_public_path__ + "static/media/ic-select-notice.d141e88197642c730f47edb880cc167b.svg";
export { ForwardRef as ReactComponent };